import WifiBoxList  from './WifiBoxList';

export default WifiBoxList;
